/**
 * @generated SignedSource<<9f6bffef584e7c54526169e693138c7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgStoresMap_stores$data = ReadonlyArray<{
  readonly id: string;
  readonly lastActiveAt: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly name: string;
  readonly " $fragmentType": "OrgStoresMap_stores";
}>;
export type OrgStoresMap_stores$key = ReadonlyArray<{
  readonly " $data"?: OrgStoresMap_stores$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgStoresMap_stores">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "OrgStoresMap_stores",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastActiveAt",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "aba31d3918a3f3773ef92bead001d23e";

export default node;
